import React, { useState, useEffect } from 'react';
import { FileText, Search, Plus, Download } from 'lucide-react';

function TaxReporting() {
  const [loading, setLoading] = useState(true);
  const [, setData] = useState([]);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setLoading(false);
      setData([]);
    }, 1000);
  }, []);

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">로딩 중...</div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>세금 신고</h1>
      </div>

      <div className="controls">
        <div className="search-filter">
          <div className="search-box">
            <Search size={20} />
            <input
              type="text"
              placeholder="검색..."
              className="form-input"
            />
          </div>
        </div>

        <div className="actions">
          <button className="btn btn-secondary">
            <Download size={16} />
            내보내기
          </button>
          <button className="btn btn-primary">
            <Plus size={16} />
            새 항목
          </button>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>항목</th>
              <th>상태</th>
              <th>날짜</th>
              <th>작업</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="4" className="empty-state">
                <div>
                  <FileText size={48} />
                  <h3>세금 신고 데이터가 없습니다</h3>
                  <p>새 항목을 추가해보세요.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TaxReporting; 